import printReportAction from '@/components/nsw-components/PrintReportsAction';
import DocumentNewVersionAction from '@/components/nsw-components/DocumentNewVersionAction';

export default {
	actions: [printReportAction.printReport('MDH', 'mdhformid', 'reports.label.mdhealt'), DocumentNewVersionAction.newVersion(null)],
	formactions: [printReportAction.printReport('MDH', 'mdhformid', 'reports.label.mdhealt'), DocumentNewVersionAction.newVersion(null)]
};
